import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const Detail = lazy(() => import('./:id/Index'))
const Claims = lazy(() => import('./claims/Index'))
const Proposals = lazy(() => import('./proposals/Index'))

export const CreditCardStatementRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--accounting--purchase']}>
    <Route index element={<Index />} />
    <Route path='claims' element={<Claims />} />
    <Route path='proposals' element={<Proposals />} />
    <Route path=':id' element={<Detail />} />
  </SubRouter>
))
